import React from 'react';
import { Button, Sprite } from '@agissc/ktag-map';

interface ToolDialogSubtitleProps {
  title: string;
  icon?: string;
  onClick?: () => void;
}

const ToolDialogSubtitle = ({ title, icon, onClick }: ToolDialogSubtitleProps) => {
  const handleIconClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className="tooldialog__subtitle">
      <h2>{title}</h2>
      {icon && (
        <Button
          onClick={handleIconClick}
          additionalClassNames="tooldialog__subtitle-icon-button"
        >
          <Sprite id={icon} additionalClassNames="tooldialog__subtitle-icon" />
        </Button>
      )}
    </div>
  );
};

export default ToolDialogSubtitle;
